import tokens from '@/PrimeVue/customDesignTokens';

export default {
  option: {
    focus: {
      background: tokens.list.option.background.colors.hover
    },
    padding: '3px 12px',
    selected: {
      background: tokens.list.option.background.colors.selected,
      focusBackground: tokens.list.option.background.colors.hoverSelected,
      color: tokens.list.option.text.colors.selected,
      focusColor: tokens.list.option.text.colors.selected
    }
  },
  padding: '0',
  header: {
    padding: '0 1rem'
  }
};